export default __webpack_public_path__ + "static/doodle-arrow-e9766b0adb98513f453b7c708db8f835.svg";